import { AdminDashboardCard } from '@components'
import { SummaryDashboard } from '@types'
import { FC } from 'react'
import { NavigateOptions } from 'react-router-dom'

import { Style } from './style'

type AdminDashboardListProps = {
  adminDashboardList: SummaryDashboard[]
  handleClickDashboardCard: (dashboardId: string, option?: NavigateOptions) => void
  isAllowUpdateStatus?: boolean
}

const AdminDashboardList: FC<AdminDashboardListProps> = ({ adminDashboardList, handleClickDashboardCard, isAllowUpdateStatus }) => {
  return (
    <Style>
      <div className='head'>Summary Managements ( {adminDashboardList.length} )</div>
      <div className='list'>
        {adminDashboardList.map((board, index) => (
          <AdminDashboardCard key={board.id} board={board} index={index + 1} onClick={handleClickDashboardCard} isAllowUpdateStatus={isAllowUpdateStatus} />
        ))}
      </div>
    </Style>
  )
}

export default AdminDashboardList
